
// ===== Menu Click Script =====

document.addEventListener("DOMContentLoaded", function () {
 
  const parentMenuItems = document.querySelectorAll(
    ".f-mobile-nav__item--has-child"
  );

  parentMenuItems.forEach((item) => {
    const link = item.querySelector(".f-mobile-nav__link");
    const arrowTrigger = item.querySelector("[data-trigger]");


    if (link && arrowTrigger) {
      link.addEventListener("click", function (e) {
        e.preventDefault(); 
        arrowTrigger.click(); 
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.video-call').forEach(function(btn){
    btn.addEventListener('click', function(){
      var modal = document.getElementById('myModal');
      if(modal){
        modal.style.display = 'block'; // modal open
      }

      // Close button
      var closeBtn = modal.querySelector('.close');
      if(closeBtn){
        closeBtn.addEventListener('click', function(){
          modal.style.display = 'none';
        });
      }

      // Click outside modal to close
      window.addEventListener('click', function(event){
        if(event.target == modal){
          modal.style.display = 'none';
        }
      });
    });
  });
});


// document.addEventListener("DOMContentLoaded", function () {

//     const stockCount = document.getElementById("stock-count");

//     let currentStock = 5;

//     function updateStock() {

//         // 50% chance same number rahe
//         const shouldChange = Math.random() > 0.5;

//         if (shouldChange) {

//             // decrease ya increase slightly
//             const change = Math.random() > 0.5 ? 1 : -1;

//             currentStock += change;

//             // limit between 3 and 5
//             if (currentStock < 3) currentStock = 3;
//             if (currentStock > 5) currentStock = 5;
//         }

//         stockCount.textContent = currentStock;
//     }

//     // every 20 sec
//     setInterval(updateStock, 20000);

// });


document.addEventListener("DOMContentLoaded", function () {

    const stockCount = document.getElementById("stock-count");

    if (!stockCount) return;

    let currentStock = 5;

    function updateStock() {

        // 50% chance same number rahe
        const shouldChange = Math.random() > 0.5;

        if (shouldChange) {

            // decrease ya increase slightly
            const change = Math.random() > 0.5 ? 1 : -1;

            currentStock += change;

            // limit between 3 and 5
            if (currentStock < 3) currentStock = 3;
            if (currentStock > 5) currentStock = 5;
        }

        stockCount.textContent = currentStock;
    }

    // every 20 sec
    setInterval(updateStock, 20000);

});





// Function to check product title and remove swatch-size-chart
function removeSizeChart() {

  var productTitleEl = document.querySelector('.f-product-single__title');
  if (!productTitleEl) return;

  var productTitle = productTitleEl.textContent.trim().toLowerCase();

  // Multiple keywords
  var keywords = ['saree', 'unstitched'];

  // Check if any keyword matches
  var matched = keywords.some(function(keyword) {
    return productTitle.includes(keyword);
  });

  if (matched) {

    var sizeCharts = document.querySelectorAll('.swatch-size-chart');

    sizeCharts.forEach(function(el) {
      el.remove();
    });

    console.log('Keyword detected: .swatch-size-chart removed');
  }
}

// Initial check
removeSizeChart();

// Observe changes in DOM
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      removeSizeChart();
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});



// function injectTrashIcon(btn) {
function replaceRemoveWithIcon() {
  document.querySelectorAll('.f-cart-drawer__remove').forEach(btn => {
    // Agar icon already hai, skip
    if (btn.querySelector('svg')) return;

    btn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
        class="bi bi-trash3" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"/>
      </svg>
    `;
  });
}

// Run once on load
document.addEventListener("DOMContentLoaded", replaceRemoveWithIcon);

// Run after cart updates
document.addEventListener("cart:updated", replaceRemoveWithIcon);
document.addEventListener("shopify:section:load", replaceRemoveWithIcon);

// Observe live DOM changes
new MutationObserver(replaceRemoveWithIcon).observe(document.body, {
  childList: true,
  subtree: true
});


// -----------  search bar  ----------------

const fixedText = "Search for ";
const words = [
  "Sarees..",
  "Pre-Draped..",
  "Ready Made Suit..",
  "Unstitched Suit..",
  "Bridal Lehengas..",
  "Non Bridal.."
];

let wordIndex = 0;
let charIndex = 0;
let isDeleting = false;

const input = document.getElementById("dynamicSearch");

function typeEffect() {
  const currentWord = words[wordIndex];
  
  if (!isDeleting) {
    charIndex++;
  } else {
    charIndex--;
  }

  input.setAttribute(
    "placeholder",
    fixedText + currentWord.substring(0, charIndex)
  );

  if (!isDeleting && charIndex === currentWord.length) {
    setTimeout(() => isDeleting = true, 1000);
  } 
  else if (isDeleting && charIndex === 0) {
    isDeleting = false;
    wordIndex = (wordIndex + 1) % words.length;
  }

  setTimeout(typeEffect, isDeleting ? 50 : 100);
}

typeEffect();



// ----- search draer open- ------

document.addEventListener("DOMContentLoaded", function() {

  const searchBox = document.querySelector(".search-bx-app");
  const searchOpener = document.querySelector('.site-header__search');

  if(searchBox && searchOpener){
    searchBox.addEventListener("click", function(){
      searchOpener.querySelector("button").click();
    });
  }

});


document.addEventListener("DOMContentLoaded", function () {
  var loyaltyLink = document.getElementById("mobile-sticky-link-link_kFfTi6");
  var drawerBtn = document.getElementById("krt-app-drawer-trigger");

  if (loyaltyLink && drawerBtn) {
    loyaltyLink.addEventListener("click", function (e) {
      e.preventDefault(); // link reload stop karega
      drawerBtn.click(); // drawer open
    });
  }
});



// -------- menu js  ------


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".money").forEach(function (el) {
    let text = el.innerText.trim();

    // Agar .00 end me hai toh remove karo
    if (text.endsWith(".00")) {
      el.innerText = text.replace(".00", "");
    }
  });
});

// ----- js -----

document.addEventListener('DOMContentLoaded', function() {
  function equalizeCardHeights() {
    var cards = document.querySelectorAll('.f-column .product-card');
    if (!cards.length) return;

    cards.forEach(function(card) {
      card.style.height = 'auto';
    });

    var maxHeight = 0;
    cards.forEach(function(card) {
      var h = card.offsetHeight;
      if (h > maxHeight) maxHeight = h;
    });

    cards.forEach(function(card) {
      card.style.height = maxHeight + 'px';
      card.style.overflow = 'hidden';   // <-- ye line missing thi, isi se overlap ho raha tha
      card.style.display = 'flex';
      card.style.flexDirection = 'column';
    });
  }

  // Multiple baar chalao — images/swatches late load hote hain
  setTimeout(equalizeCardHeights, 500);
  setTimeout(equalizeCardHeights, 1200);
  setTimeout(equalizeCardHeights, 2500);
  window.addEventListener('load', equalizeCardHeights);
  window.addEventListener('resize', function() {
    setTimeout(equalizeCardHeights, 300);
  });
});